import { CHANGE_LANGUAGE } from '../type';

const initialState = {
  language: 'tr',
};

export default function settingReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
}
